export const orderValidationApiResponse = error => error?.response?.data?.error || error?.response?.data || error
